export default {"src":"/_next/static/media/CredlixWhite_logo_new.7123d838.svg","height":820,"width":2529};